export default __webpack_public_path__ + "assets/favicon/R_favicon_error.7cda1b50.ico";